import axios from 'axios';

const CartService = {
    async fetchCheckout() {
        return axios.get('/cart/api/index');
    },
    async loadPoliticUrl() {
        return axios.get('/cart/api/politicUrl');
    },
    async loadCities(tk) {
        return axios.post('/cart/api/cities', {
            tk
        })
    },
    async isAllowed(company, district, city) {
        return axios.post('/cart/api/delivery-cost/is-allowed', {
            company,
            district,
            city
        })
    },
    async fetchDeliveryCostByTk(pickupPoint) {
        return axios.post('/cart/api/delivery-cost/by-tk', {
            pickupPoint,
        })
    },
    async fetchDeliveryCost(deliveryCompany, daDataResult, address) {
        return axios.post('/cart/api/delivery-cost/to-hands', {
            deliveryCompany,
            daDataResult,
            address
        })
    },
    async add(buyable, id, quantity) {
        return axios.post('/cart/api/add', {
            buyable,
            id,
            quantity
        });
    },
    async remove(key) {
        return axios.post('/cart/api/remove', {
            key
        });
    },
    async increase(key, amount) {
        return axios.post('/cart/api/increase', {
            key,
            amount
        });
    },
    async decrease(key, amount) {
        return axios.post('/cart/api/decrease', {
            key,
            amount
        });
    },

};

export default CartService;